import { render, staticRenderFns } from "./LoyaltyCertTypeUpdateComponent.vue?vue&type=template&id=02b3d10c&scoped=true"
import script from "./LoyaltyCertTypeUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyCertTypeUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b3d10c",
  null
  
)

export default component.exports